module.exports = __webpack_public_path__ + "img/Group 5.f03e73b3.svg";